import axios from "axios";
import { DESIGNERS_URL } from "../../API/Api";

const GetAllDesigners = async (token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`
    }
    const response = await axios({
        method: "GET",
        baseURL: `${DESIGNERS_URL}?return_all=1`,
        headers,
    })
    return response.data
}

const SearchONDesigners = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`
    }

    const response = await axios({
        method: "GET",
        baseURL: `${DESIGNERS_URL}/search`,
        headers,
        params: data
    })
    return response.data;
}

const GetSingleDesigner = async (id, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`
    }
    const response = await axios({
        method: "GET",
        baseURL: `${DESIGNERS_URL}/${id}`,
        headers,
    })
    return response.data;
}

const CreateNewDesigner = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`
    }
    const response = await axios({
        method: "POST",
        baseURL: `${DESIGNERS_URL}/create`,
        headers,
        data: data,
    })
    return response.data
}

const UpdateDesignerData = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`
    }
    const response = await axios({
        method: "PUT",
        baseURL: `${DESIGNERS_URL}/update/${data.id}`,
        headers,
        data: data,
    })
    return response.data
}

const DeleteDesignerAction = async (id, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`
    }

    const response = await axios({
        method: "DELETE",
        baseURL: `${DESIGNERS_URL}/delete/${id}`,
        headers,
    })

    return response.data
}

const DesignerService = {
    GetAllDesigners,
    SearchONDesigners,
    CreateNewDesigner,
    GetSingleDesigner,
    UpdateDesignerData,
    DeleteDesignerAction,
}

export default DesignerService;